<template>
    <div>
        <div class="page-breadcrumb">
            <div class="row">
                <div class="col-5 align-self-center">
                    <h4 class="page-title">Dashboard</h4>
                    <div class="d-flex align-items-center">
                        <nav aria-label="breadcrumb">
                            <ol class="breadcrumb">
                                <li class="breadcrumb-item"><a href="#">Home</a></li>
                                <li class="breadcrumb-item active" aria-current="page">Library</li>
                            </ol>
                        </nav>
                    </div>
                </div>
            </div>
        </div>
        <div class="container-fluid">
            <div class="row">
                <!-- Column -->
                <div class="col-sm-12 col-lg-4">
                    <div class="card">
                        <div class="card-body">
                            <h4 class="card-title">Sales</h4>
                            <h5 class="card-subtitle">Total Sales this year</h5>
                            <h3 class="font-medium">₹&nbsp;{{this.sales | unitFix(2)}}</h3>
                        </div>
                        <div class="earningsbox m-t-5" style="height:78px; width:100%;"></div>
                    </div>
                </div>
                <!-- Column -->
                <div class="col-sm-12 col-lg-8">
                    <div class="card">
                        <div class="card-body border-bottom">
                            <h4 class="card-title">{{ $t('Dashboard.Overview') }}</h4>
                            <h5 class="card-subtitle">Overview for the year</h5>
                        </div>
                        <div class="card-body">
                            <div class="row m-t-10">
                                <div class="col-md-6 col-sm-12 col-lg-6">
                                    <div class="d-flex align-items-center">
                                        <div class="m-r-10"><span class="text-light-green display-4"><i
                                                class="mdi mdi-chart-areaspline"></i></span></div>
                                        <div>
                                            <span class="text-muted">Surplus / (Shortfall)</span>
                                            <h3 class="font-medium m-b-0" v-if="totalProfit>0">₹&nbsp;{{this.totalProfit | unitFix(2)}}</h3>
                                            <h3 class="font-medium m-b-0 text-danger" v-else>₹&nbsp;({{this.totalProfit*-1 | unitFix(2)}})</h3>
                                        </div>
                                    </div>
                                </div>
                                <div class="col-md-6 col-sm-12 col-lg-6">
                                    <div class="d-flex align-items-center">
                                        <div class="m-r-10"><span class="display-4"><i class="mdi mdi-credit-card"></i></span>
                                        </div>
                                        <div>
                                            <span class="text-muted">Purchases</span>
                                            <h3 class="font-medium m-b-0">₹&nbsp;{{this.purchases | unitFix(2)}}</h3>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
    import {mapGetters} from "vuex";

    export default {
        name: "AdminDashboard",
        computed: {
            ...mapGetters(["currentUser", "currentOrg"])
        },
        data() {
            return {
                purchases: 0,
                sales: 0,
                totalProfit: 0
            }
        },
        mounted() {
            this.init();
        },
        methods: {
            async init() {
                await this.getTotalPurchase();
                await this.getTotalSale();
                this.getTotalProfit();
            },
            async getTotalPurchase() {
                try {
                    let {data} = await this.$http.get(`/express/${this.currentOrg.express_id}/totalPurchases`);
                    this.purchases = data.total;
                } catch (e) {

                }
            },
            async getTotalSale() {
                try {
                    let {data} = await this.$http.get(`/express/${this.currentOrg.express_id}/totalSales`);
                    this.sales = data.total;
                } catch (e) {

                }
            },
            getTotalProfit() {
                let profit = Number(this.sales) - Number(this.purchases);
                // this.totalProfit = Math.max(0, profit);
                this.totalProfit = profit;
            }
        }
    }
</script>

<style scoped>

</style>
